import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { VaIconModule, VaImageGalleryComponent, VaSafeHtmlModule } from '@vendasta/uikit';

import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { VaAddonListModule } from '../addon-list/addon-list.module';
import baseTranslation from '../assets/i18n/en_devel.json';
import { VaFaqsModule } from '../faqs/faqs.module';
import { VaFilesModule } from '../files/files.module';
import { VaHeaderContainerModule } from '../header-container/header-container.module';
import { VaPricingModule } from '../pricing/pricing.module';
import { VaProductsNavModule } from '../products-nav/products-nav.module';
import { VaSellingInfoModule } from '../selling-info/selling-info.module';
import { WEBLATE_COMPONENT_NAME } from '../shared/constants';
import { VaPackageDetailsV2Component } from './package-details-v2.component';

@NgModule({
  imports: [
    VaImageGalleryComponent,
    CommonModule,
    MatIconModule,
    VaSafeHtmlModule,
    VaIconModule,
    VaPricingModule,
    MatButtonModule,
    VaFilesModule,
    VaFaqsModule,
    VaSellingInfoModule,
    VaHeaderContainerModule,
    VaAddonListModule,
    VaProductsNavModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
  ],
  declarations: [VaPackageDetailsV2Component],
  exports: [VaPackageDetailsV2Component],
})
export class VaPackageDetailsV2Module {}
